export default __webpack_public_path__ + "static/media/imgLoja03.93d95f6f.png";